import { theme } from '@kijiji/theme'
import get from 'lodash/get'

export const getColorFromHexOrConst = (color: string) => {
  // color format is e.g. "green-primary" or "#fff"
  const isHex = color.startsWith('#')

  return isHex ? color : get(theme.colors, color.replace('-', '.'), 'inherit')
}
